import styled from 'styled-components'

export const HeaderWrapper = styled.header`
	height: var(--it-hg-lg);
	// background-color: white;
	background-color: var(--header-color);
`

export const ImageWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`

export const Image = styled.img`
	height: 80px;
	margin-top: -18px;
	// height: var(--it-hg-md);
	// margin-top: 5px;
	// margin-left: 10px;
`
export const LogoutWrapper = styled.div`
	margin-top: 1.7vh;
	margin-right: 2vh;
	font-size: 12px;
	letter-spacing: 0.5px;
	color: #ffb400;
	cursor: pointer;
`

export const DownloadBanner = styled.img`
	height: 60px;
	width: 100%;
	margin-top: -25px;
`
